export const SITE_NAME = 'Нейросфера'
export const ORGANIZATION_NAME = 'ЦИТ Нейросфера'
export const EMAIL = 'info@cit-neurosfera.ru'
export const PHONE = '+7 937 06 09 009'
export const ORGANIZATION_ID = '#organization'
export const WEBSITE_ID = '#website'

export const FALLBACK_PRODUCTS = []

const pageMeta = {
  '/': {
    name: 'Нейросфера — программные решения для бизнеса',
    title: 'Нейросфера — программные решения для бизнеса',
    description: 'Разработка и внедрение программных решений для автоматизации бизнеса.',
  },
  '/services': {
    name: 'Услуги',
    title: 'Услуги — Нейросфера',
    description: 'Исследование, проектирование, разработка и внедрение цифровых решений.',
  },
  '/client': {
    name: 'Клиентам',
    title: 'Клиентам — Нейросфера',
    description: 'Сотрудничество с Нейросферой и разработка решений под задачи бизнеса.',
  },
  '/partners': {
    name: 'Партнерам',
    title: 'Партнерам — Нейросфера',
    description: 'Партнерские программы и совместные проекты Нейросферы.',
  },
  '/product': {
    name: 'Продукты',
    title: 'Продукты — Нейросфера',
    description: 'Программные продукты Нейросферы для автоматизации бизнеса.',
  },
  '/product/calculator': {
    name: 'Калькулятор стоимости',
    title: 'Калькулятор стоимости — Нейросфера',
    description: 'Расчет стоимости программных продуктов и услуг Нейросферы.',
  },
  '/privacy': {
    name: 'Политика конфиденциальности',
    title: 'Политика конфиденциальности — Нейросфера',
    description: 'Политика обработки персональных данных ЦИТ Нейросфера.',
  },
}

export function getBaseUrl() {
  if (typeof window !== 'undefined') return window.location.origin
  return 'https://cit-neurosfera.ru'
}

export function getPageMeta(pathname, product) {
  if (product) {
    const name = product.page_title || product.module || 'Продукт'
    return {
      name,
      title: `${name} — ${SITE_NAME}`,
      description: product.page_summary || product.design || 'Программный продукт Нейросферы.',
    }
  }

  return pageMeta[pathname] || {
    name: SITE_NAME,
    title: SITE_NAME,
    description: 'Программные решения для автоматизации бизнеса.',
  }
}
